function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.980392%,10.980392%,10.588235%)",
      fillOpacity: 1
    },
    d: "M 12.34375 16 L 3.65625 16 C 1.644531 16 0 14.351562 0 12.34375 L 0 3.65625 C 0 1.648438 1.648438 0 3.65625 0 L 12.34375 0 C 14.355469 0 16 1.648438 16 3.65625 L 16 12.34375 C 16 14.355469 14.355469 16 12.34375 16 Z M 12.34375 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.238281 3.773438 L 6.929688 8.707031 L 3.214844 12.71875 L 4.050781 12.71875 L 7.304688 9.207031 L 9.929688 12.71875 L 12.773438 12.71875 L 8.875 7.507812 L 12.332031 3.773438 L 11.496094 3.773438 L 8.503906 7.007812 L 6.082031 3.773438 Z M 4.46875 4.390625 L 5.773438 4.390625 L 11.542969 12.101562 L 10.238281 12.101562 Z M 4.46875 4.390625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMini);
export default __webpack_public_path__ + "static/media/x_mini.574e9e6528a10680b1779dbb9f93ef1d.svg";
export { ForwardRef as ReactComponent };